import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../old/beheer/store";

export const selectSalesAreaId = createSelector(
  [(state: RootState) => state.filtersV2.vestiging_id],
  (vestigingIdFilter): number | undefined => {
    if (vestigingIdFilter?.value) {
      return vestigingIdFilter?.value;
    } else {
      return undefined;
    }
  }
);
